export default "__VITE_ASSET__5e0b0b41__"